// extracted by mini-css-extract-plugin
module.exports = {"Sidebar":"Sidebar_Sidebar__c0TTh","margin-10":"Sidebar_margin-10__aP5WM"};